import PropTypes from 'prop-types'
import React from 'react'
import { routerPropTypes } from 'Types'
import { withRouter } from 'react-router'

class NotFound extends React.Component {
  static propTypes = {
    ...routerPropTypes,
    staticContext: PropTypes.shape({
      notFound: PropTypes.any
    })
  }

  constructor(props) {
    super()
    if (props.staticContext) {
      props.staticContext.notFound = true
    }
  }

  componentDidMount() {
    this.props.history.push('/')
  }

  render() {
    return <div>Gone</div>
  }
}

export default withRouter(NotFound)
